import { getCurrentPlanFn } from '@/http/modules/examSet/examBatch'
const state = () => ({
    currentPlanFromStore: {}
})

// getters
const getters = {}

// actions
const actions = {
    getCurrentPlanAction({ commit }) {
        return new Promise(resolve => {
          getCurrentPlanFn().then(({data: plan}) => {
            commit('setCurrentPlan', plan)
            resolve(plan)
          })
        })
    }
}

// mutations
const mutations = {
    setCurrentPlan(state, plan) {
        state.currentPlanFromStore = plan
    }
}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}
